<template>
  <div>
    <div class="row mb-3">
      <div class="col-lg-3">
        <label>Event Types</label>
        <multiselect v-model="typeFilters" :options="typeOptions" :multiple="true" :searchable="true" :close-on-select="false" :show-labels="false" placeholder="Filter by Event Types"></multiselect>
      </div>
      <div class="col-lg-3">
        <label>Countries</label>
        <multiselect v-model="countryFilters" :options="countries" :multiple="true" :searchable="true" :close-on-select="false" :show-labels="false" placeholder="Filter by Countries"></multiselect>
      </div>
      <div class="col-lg-3">
        <label>Topic Areas</label>
        <multiselect v-model="focusAreaFilters" :options="focusAreaOptions" :multiple="true" :searchable="true" :close-on-select="false" :show-labels="false" placeholder="Filter by Topic Areas"></multiselect>
      </div>
      <div class="col-lg-3">
        <label>Start Date <span v-if="dateFilter" @click="clearDateFilter()" style="cursor: pointer; color: gray;">(Clear Filter)</span></label>
        <!-- <multiselect v-model="skillsFilters" :options="skillsOptions" :multiple="true" :searchable="true" :close-on-select="false" :show-labels="false" placeholder="Filter by Skills"></multiselect> -->
        <datepicker class="form-control" placeholder="" v-model="dateFilter" style="padding: .37rem .75rem; line-height: 1;"></datepicker>
        <!-- {{ dateFilter }} -->
      </div>
    </div>

    <div v-for="listing in filteredListings" :key="listing.id">
      <div class="listing-tile mb-1" style="text-decoration: none;">
        <router-link :to="{ name: 'Event', params: { id: listing.id } }" style="text-decoration: none; color: var(--coredarkcolor);">
          <h3 style="margin-bottom: 0;">{{ listing.title }}<span v-if="listing.event_type"> ({{ listing.event_type }})</span></h3>
        </router-link>
        <h5 class="mt-1">{{ listing.poster_name }}</h5>
        <img v-if="(listing.poster == loggedinUser || $store.getters.isAgent) && ($router.history.current.path !='/events')" @click="editListing(listing)" src="../../assets/img/icons/edit_icon_simple.svg" style="float: right; cursor: pointer;" width="16px;" alt="Edit" >
        <hr class="mr-3">
        <div class="row">
          <div class="col-lg-6 mb-2">
            <strong>{{ listing.city }}<span v-if="listing.city && listing.country">, </span>{{ listing.country }}</strong>
            <!-- https://stackoverflow.com/questions/42129534/vuejs-how-to-output-a-comma-separated-array -->
            <p v-if="listing.categories[0]">Topic Areas: {{ listing.categories.join(', ') }}</p>
            <!-- <hr> -->
          </div>
          <div class="col-lg-6" style="text-align: right;">
            <p v-if="listing.fee">{{ listing.fee }}</p>
            <p v-if="listing.date">{{ new Date(listing.date.concat('T00:00:00')).toDateString() }}<span v-if="listing.end_date"> - {{ new Date(listing.end_date.concat('T00:00:00')).toDateString() }}</span></p>
            <p><span v-if="listing.start_time">{{ listing.start_time | trimSeconds }}</span><span v-if="listing.end_time"> - {{ listing.end_time | trimSeconds }}</span> {{ listing.timezone }}</p>
            <!-- <hr> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios';
import router from '../../router'
import Datepicker from 'vuejs-datepicker'; // https://www.npmjs.com/package/vuejs-datepicker

import ListingEdit from './EventForm'

// https://www.npmjs.com/package/vue-loading-overlay
import Vue from 'vue';
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
// Init plugin
Vue.use(Loading);

export default {
  props: ['posterID', 'listings'],
  data() {
    return {
      // jobs: [],
      loggedinUser: null,

      typeOptions: [],
      typeFilters: [],
      countryFilters: [],
      countries: [],
      focusAreaFilters: [],
      focusAreaOptions: [],
      dateFilter: null,
    }
  },
  components: {
    appListingEdit: ListingEdit,
    Datepicker, // https://www.npmjs.com/package/vuejs-datepicker
  },
  created() {
    this.loggedinUser = this.$store.getters.userID

    this.typeOptions = this.$store.getters.eventTypes
    this.countries = this.$store.getters.countries
    this.focusAreaOptions = this.$store.getters.focusAreas

    // This is used to pre-apply filters when someone arrives on the event list by searching on the home page
    if (this.$route.params.type && (this.$route.params.type != 'All Event Types')) {
      this.typeFilters.push(this.$route.params.type)
    }
    if (this.$route.params.country && (this.$route.params.country != 'All Countries')) {
      this.countryFilters.push(this.$route.params.country)
    }
    if (this.$route.params.topic && (this.$route.params.topic != 'All Topic Areas')) {
      this.focusAreaFilters.push(this.$route.params.topic)
    }
  },
  computed: {
    filteredListings() {
      var typeFilteredListings = []
      if (this.typeFilters.length > 0) {
        for (var listing in this.listings) {
          if (this.typeFilters.includes(this.listings[listing].event_type)) {
            typeFilteredListings.push(this.listings[listing])
          }
        }
      } else {
        typeFilteredListings = this.listings
      }

      var countryFilteredListings = []
      if (this.countryFilters.length > 0) {
        for (var listing in typeFilteredListings) {
          if (this.countryFilters.includes(typeFilteredListings[listing].country)) {
            countryFilteredListings.push(typeFilteredListings[listing])
          }
        }
      } else {
        countryFilteredListings = typeFilteredListings
      }

      var focusAreaFilteredListings = []
      if (this.focusAreaFilters.length > 0) {
        for (var listing in countryFilteredListings) {
          for (var focusArea in this.focusAreaFilters) {
            if (countryFilteredListings[listing].categories.includes(this.focusAreaFilters[focusArea])) {
              focusAreaFilteredListings.push(countryFilteredListings[listing])
              break
            }
          }
        }
      } else {
        focusAreaFilteredListings = countryFilteredListings
      }

      var dateFilteredListings = []
      if (this.dateFilter) {
        let djangoFilterDate =
          this.dateFilter.getFullYear().toString() +
          // https://stackoverflow.com/questions/8169785/how-to-prepend-a-zero-in-front-of-any-number-below-10-in-javascript-using-regexp
          '-' + ('0' + (this.dateFilter.getMonth()+1).toString()).slice(-2) +
          '-' + ('0' + this.dateFilter.getDate().toString()).slice(-2)
        for (var listing in focusAreaFilteredListings) {
          if (focusAreaFilteredListings[listing].date == djangoFilterDate) {
            dateFilteredListings.push(focusAreaFilteredListings[listing])
          }
        }
      } else {
        dateFilteredListings = focusAreaFilteredListings
      }

      return dateFilteredListings
    },
  },
  methods: {
    showListing(listingID) {
      router.replace({ name: 'Event', params: { id: listingID } })
    },
    editListing(listing) {
      console.log('Edit Icon Clicked')
      this.$emit('editListing', listing) // Lecture 112
    },
    clearDateFilter() {
      this.dateFilter = null
    }
  },
}

</script>



// WEBPACK FOOTER //
// src/components/events/EventList.vue